module.exports = __webpack_public_path__ + "bg35-blue-f620f86805d1ca539a2233a86b6c7731.png";